import { IconPencil, IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import IconButton from '../../../components/Buttons/IconButton';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import { ensureHttpPrefix } from '../../../utils/url.utils';

const EditQrModal = ({ baseData, callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const submit = async () => {
        let postData = {
            "fallbackUrl": ensureHttpPrefix(document.getElementById("link").value?.trim()),
            "linkId": baseData?.linkId
        }
        if (document.getElementById("name").value?.trim()) {
            postData.linkName = document.getElementById("name").value?.trim();
        }
        let resp = await postApi(postData, urlApi.updateQr);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            if (callback) {
                callback();
            }
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }
    return (
        <>
            <IconButton icon={< IconPencil size={16} />} onClickFunction={handleShow} />
            <Modal show={show} onHide={handleClose} >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Update Destination Link</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <div className='mb-3'>
                        <label htmlFor="link" className='text-sm font-semibold mb-1'>Destination</label>
                        <input type='text' id='link' className='w-full px-3 py-2 rounded-md border-2 text-sm' defaultValue={baseData?.mainLink} />
                    </div>
                    <div className='mb-4'>
                        <label htmlFor="" className='text-sm font-semibold mb-1'>Title (Optional)</label>
                        <input type='text' id='name' className='w-full px-3 py-2 rounded-md border-2 text-sm' placeholder='Enter link title...' defaultValue={baseData?.linkName} />
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditQrModal